import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Modal from "react-modal";
import GraphicalReport from "../report-modal-sections/GraphicalReport";
import "../../../../styles/member-report/graphical-report.css";
import "../../../../styles/member-report/member-report-modal.css";
import {
  formatSelectedDate,
  formatSelectedTimeSlots,
  getBuildingIcon,
  getCommaSeparatedValues,
  getRightArrowIcon,
} from "../MemberReportMocks";
import MemberDetailedReport from "../report-modal-sections/MemberDetailedReport";
import MemberGymwiseStats from "../report-modal-sections/MemberGymwiseStats";
import MemberReportFilter from "../member-checkins-stat/MemberReportFilter";
import { ReloadIcon } from "../../../../images/icons/icons";
import {
  fetchGymCardStatsData,
  fetchGymDistributionStatsData,
  fetchGymSegmentMembersBPData,
  fetchGymSegmentMembersTrialData,
  fetchGymSegmentMembersUnassignedData,
} from "../../../../redux/prospect-reducers/prospectSlice";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import StaffCalendarViewReport from "../../../trainer-report/staff-attendance-report/new-ui/StaffCalendarViewReport";
import { NoPic } from "../../../../exports/Images";
import CheckinCheckoutImg from "../../../trainer-report/staff-attendance-report/checkin-checkout/CheckinCheckoutImg";
import TrainerAttendance from "../report-modal-sections/TrainerAttendance";
import DetailModHeader from "../../../common-components/DetailModHeader";
import MemberAttendance from "../report-modal-sections/MemberAttendance";
import TrainerMemberMap from "../../../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
import BCAReport from "../../../trainer-member-engagement/bca-report/BCAReport";
import ThreedayTrialHistory from "../../../pt/three-day-trial/ThreedayTrialHistory";
import TrialAssignForm from "../../../pt/three-day-trial/TrialAssignForm";

const GymwiseCheckinsReport = ({
  userInfoData,
  rowData,
  onClose,
  prevAllFilters,
}) => {
  const dispatch = useDispatch();

  const iniAllFilter = {
    selectedDate: prevAllFilters.selectedDate || "",
    selectedCheckinTimes: prevAllFilters.selectedCheckinTimes || [],
    selectedMemberType: prevAllFilters.selectedMemberType || "",

    isBCAPage: 0,
    isTrialPage: 0,
    isUnassignedPage: 0,
    pageLimit: 10,
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const [filters, setFilters] = useState({
    gym_id: rowData?.gym_id || "",
    start_date: prevAllFilters.selectedDate || "",
    end_date: prevAllFilters.selectedDate || "",
    checkin_time_filter: getCommaSeparatedValues(prevAllFilters.selectedCheckinTimes || []),
  });

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const trainerAttendanceRef = useRef(null);
  const memberDetailedReportRef = useRef(null);
  const memberAttendanceRef = useRef(null);
  const [activeSection, setActiveSection] = useState(null);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const scrollToSection = (sectionType) => {
    setActiveSection(sectionType);

    setTimeout(() => {
      let sectionRef;
      if (sectionType === "trainer_attendance") {
        sectionRef = trainerAttendanceRef;
      } else if (sectionType === "member_attendance") {
        sectionRef = memberAttendanceRef;
      } else {
        sectionRef = memberDetailedReportRef;
      }

      if (sectionRef?.current) {
        sectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  const closeSection = () => {
    setActiveSection(null);
  };

  function getGymStats(filters) {
    dispatch(
      fetchGymCardStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getGymChartStats(filters) {
    dispatch(
      fetchGymDistributionStatsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getGymUnassignedMembers(filters, page = 0, limit = 10) {
    dispatch(
      fetchGymSegmentMembersUnassignedData({
        filters: {
          ...filters,
          filter_type: "unassigned",
          page: page,
          limit: limit,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getGymTrialMembers(filters, page = 0, limit = 10) {
    dispatch(
      fetchGymSegmentMembersTrialData({
        filters: {
          ...filters,
          filter_type: "pt_trial",
          page: page,
          limit: limit,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getGymBCAPendingMembers(filters, page = 0, limit = 10) {
    dispatch(
      fetchGymSegmentMembersBPData({
        filters: {
          ...filters,
          filter_type: "bca_pending",
          page: page,
          limit: limit,
        },
        token: userInfoData?.token,
      })
    );
  }

  function getCombinedReload() {
    getGymStats(filters);
    getGymChartStats(filters);
    getGymUnassignedMembers(
      filters,
      allFilters.isUnassignedPage,
      allFilters.pageLimit
    );
    getGymTrialMembers(filters, allFilters.isTrialPage, allFilters.pageLimit);
    getGymBCAPendingMembers(
      filters,
      allFilters.isBCAPage,
      allFilters.pageLimit
    );
  }

  useEffect(() => {
    if (filters.gym_id) {
      getCombinedReload();
    }
  }, [filters]);

  useEffect(() => {
    if (filters.gym_id) {
      getGymUnassignedMembers(
        filters,
        allFilters.isUnassignedPage,
        allFilters.pageLimit
      );
    }
  }, [allFilters.isUnassignedPage, allFilters.pageLimit]);

  useEffect(() => {
    if (filters.gym_id) {
      getGymTrialMembers(filters, allFilters.isTrialPage, allFilters.pageLimit);
    }
  }, [allFilters.isTrialPage, allFilters.pageLimit]);

  useEffect(() => {
    if (filters.gym_id) {
      getGymBCAPendingMembers(
        filters,
        allFilters.isBCAPage,
        allFilters.pageLimit
      );
    }
  }, [allFilters.isBCAPage, allFilters.pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      start_date: allFilters.selectedDate || "",
      end_date: allFilters.selectedDate || "",
      checkin_time_filter: getCommaSeparatedValues(
        allFilters.selectedCheckinTimes
      ),
    }));
  }, [allFilters.selectedDate, allFilters.selectedCheckinTimes]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "image_view" ||
            modValues.modName === "checkin_image" ||
            modValues.modName === "checkout_image"
              ? "mod-width-50p"
              : modValues.modName === "trainer_member_map"
              ? "mod-width-50p"
              : modValues.modName === "trial_assign"
              ? "mod-width-50p mod-height-60vh"
              : "mod-width-95vw mod-height-95vh"
          }`}
        >
          {modValues.modName === "trial_assign" ? null : modValues.modName ===
              "view_details" ||
            modValues.modName === "trial_history" ||
            modValues.modName === "BCA_history" ? (
            <DetailModHeader info={modValues.rowData} onClose={onCloseModal} />
          ) : (
            <ModalHeadAndClose
              title={
                modValues.modName === "image_view" ||
                modValues.modName === "checkin_image" ||
                modValues.modName === "checkout_image"
                  ? `${modValues.rowData?.name} - ${modValues.modName?.replace(
                      /_/g,
                      " "
                    )}`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />
          )}

          {modValues.modName === "view_details" ? (
            <StaffCalendarViewReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "image_view" ? (
            <div className="discussionModalMessage mt30">
              <img
                src={modValues.image || NoPic}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.modName === "checkin_image" ||
            modValues.modName === "checkout_image" ? (
            <CheckinCheckoutImg
              rowData={modValues.rowData}
              modName={modValues.modName}
            />
          ) : modValues.modName === "trial_assign" ? (
            <TrialAssignForm
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={onCloseModal}
            />
          ) : modValues.modName === "trial_history" ? (
            <ThreedayTrialHistory
              rowData={modValues.rowData}
              userInfoData={userInfoData}
            />
          ) : modValues.modName === "trainer_member_map" ? (
            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={onCloseModal}
            />
          ) : modValues.modName === "BCA_history" ? (
            <BCAReport
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <div className="mr-modal-content">
        <div className="mr-modal-header">
          <div className="mr-modal-header-left">
            <button className="mr-modal-back-btn" onClick={onClose}>
              {getRightArrowIcon()}
            </button>

            <button
              className="mr-modal-back-btn"
              onClick={() => getCombinedReload()}
            >
              {ReloadIcon()}
            </button>

            <div className="mr-modal-gym-info">
              <div className="mr-modal-gym-icon">{getBuildingIcon()}</div>

              <div className="mr-modal-gym-details">
                <h2 className="mr-modal-gym-name">
                  {rowData?.gym_name || "NA"}
                </h2>
                <div className="mr-modal-badges">
                  <span className="mr-modal-badge mr-modal-badge--status">
                    {rowData?.category_name || ""}
                  </span>

                  {(formatSelectedDate(prevAllFilters?.selectedDate) ||
                    formatSelectedTimeSlots(
                      prevAllFilters?.selectedCheckinTimes
                    )) && (
                    <div className="mr-modal-filter-info">
                      {formatSelectedDate(prevAllFilters?.selectedDate) && (
                        <div className="mr-modal-filter-date">
                          <span className="mr-modal-filter-label">Date:</span>
                          <span className="mr-modal-filter-value">
                            {formatSelectedDate(prevAllFilters.selectedDate)}
                          </span>
                        </div>
                      )}
                      {formatSelectedTimeSlots(
                        prevAllFilters?.selectedCheckinTimes
                      ) && (
                        <div className="mr-modal-filter-slots">
                          <span className="mr-modal-filter-label">Time:</span>
                          <span className="mr-modal-filter-value">
                            {formatSelectedTimeSlots(
                              prevAllFilters.selectedCheckinTimes
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="mr-modal-title-section">
          <h2 className="mr-modal-title">{rowData.name}</h2>
          <p className="mr-modal-subtitle">{rowData.location}</p>
        </div>
        <button className="mr-modal-close-btn" onClick={onClose}>
          ×
        </button> */}
        </div>

        <div className="mr-modal-body">
          <MemberReportFilter
            allFilters={allFilters}
            setAllFilters={setAllFilters}
          />

          <MemberGymwiseStats onCardClick={scrollToSection} />

          <GraphicalReport />

          <div className="mr-full-width-section" ref={memberDetailedReportRef}>
            <MemberDetailedReport
              allFilters={allFilters}
              setAllFilters={setAllFilters}
              setModValues={setModValues}
            />
          </div>

          {activeSection === "trainer_attendance" && (
            <TrainerAttendance
              userInfoData={userInfoData}
              prevFilters={filters}
              setModValues={setModValues}
              trainerAttendanceRef={trainerAttendanceRef}
              closeSection={closeSection}
            />
          )}

          {activeSection === "member_attendance" && (
            <MemberAttendance
              userInfoData={userInfoData}
              prevFilters={filters}
              setModValues={setModValues}
              memberAttendanceRef={memberAttendanceRef}
              closeSection={closeSection}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default GymwiseCheckinsReport;
